
















import { Component, Prop, Vue } from 'vue-property-decorator'
import { CameraService } from '../services/cameraService'
import { Getter } from 'vuex-class'
import { bacSlideOverService } from 'bac-frontend-common'
import SearchAreaModel from '../models/SearchAreaModel'
import CommentModel from '../models/commentModel'

@Component({})
export default class Photo extends Vue {
  camera: CameraService = new CameraService();
  width: number = 320;
  height: number = 0;
  streaming: boolean = false;
  $refs!: {
    video: HTMLVideoElement,
    canvas: HTMLCanvasElement
  }
  mediaDeviceError: boolean = false

  @Getter('composeComment') composeCommentStore!: CommentModel;

  mounted () {
    type NewType=any

    this.camera.getStream().then((stream : NewType) => {
      if (stream === 'error') {
        this.mediaDeviceError = true
      } else {
        this.$refs.video.srcObject = stream
        this.$refs.video.play()
      }
    })
  }

  takePicture () {
    const width = this.$refs.video.clientWidth
    const height = this.$refs.video.clientHeight

    const context = this.$refs.canvas.getContext('2d')
    this.$refs.canvas.width = width
    this.$refs.canvas.height = height

    if (context) {
      context.drawImage(this.$refs.video, 0, 0, width, height)
    }
    const data = this.$refs.canvas.toDataURL('image/png')
    this.composeCommentStore.setImg(data)

    this.camera.closeStream(this.$refs.video.srcObject)

    bacSlideOverService.closeCurrentSlideOver()
  }

  beforeDestroy () {
    // Make sure to close the video stream if still active
    if (this.$refs.video.srcObject) {
      this.camera.closeStream(this.$refs.video.srcObject)
    }
  }

}
